import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title }: { title: string }) => {
  return (
    <Helmet>
      <title>{title} | WEBFUZE</title>
    </Helmet>
  );
};

export default PageTitle;
